/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskOverviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskOverviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskOverviewSecurity = {
  option1?: GetRiskOverviewSecurityOption1 | undefined;
  option2?: GetRiskOverviewSecurityOption2 | undefined;
};

export type GetRiskOverviewRequest = {
  /**
   * Inclusive start of the overview window. Defaults to the start of the 7-day calendar window ending at to.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the overview window. Defaults to now.
   */
  to?: Date | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskOverviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskOverviewSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskOverviewSecurityOption1$Outbound,
  GetRiskOverviewSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskOverviewSecurityOption1ToJSON(
  getRiskOverviewSecurityOption1: GetRiskOverviewSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskOverviewSecurityOption1$outboundSchema.parse(
      getRiskOverviewSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskOverviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskOverviewSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskOverviewSecurityOption2$Outbound,
  GetRiskOverviewSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskOverviewSecurityOption2ToJSON(
  getRiskOverviewSecurityOption2: GetRiskOverviewSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskOverviewSecurityOption2$outboundSchema.parse(
      getRiskOverviewSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskOverviewSecurity$Outbound = {
  Option1?: GetRiskOverviewSecurityOption1$Outbound | undefined;
  Option2?: GetRiskOverviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskOverviewSecurity$outboundSchema: z.ZodMiniType<
  GetRiskOverviewSecurity$Outbound,
  GetRiskOverviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskOverviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskOverviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskOverviewSecurityToJSON(
  getRiskOverviewSecurity: GetRiskOverviewSecurity,
): string {
  return JSON.stringify(
    GetRiskOverviewSecurity$outboundSchema.parse(getRiskOverviewSecurity),
  );
}

/** @internal */
export type GetRiskOverviewRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskOverviewRequest$outboundSchema: z.ZodMiniType<
  GetRiskOverviewRequest$Outbound,
  GetRiskOverviewRequest
> = z.pipe(
  z.object({
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskOverviewRequestToJSON(
  getRiskOverviewRequest: GetRiskOverviewRequest,
): string {
  return JSON.stringify(
    GetRiskOverviewRequest$outboundSchema.parse(getRiskOverviewRequest),
  );
}
